import { createEvent, restore } from 'effector'

import type { ClientRuntime } from '@portal/portal-api'

import { persist } from '@/shared/lib/persist/local'

export const clientRuntimeSelected = createEvent<ClientRuntime>()

export const $clientRuntime = restore(clientRuntimeSelected, 'haxe')

persist({
    store: $clientRuntime,
    key: 'game.clientRuntime',
})
